import { FunctionComponent, useContext, useEffect, useState } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next/pages";
import { useInView } from "react-intersection-observer";
import AppContext from "context/AppContext";
import styles from "../../styles/home/Trustedby.module.css";

interface TrustedbyProps { }

const Trustedby: FunctionComponent<TrustedbyProps> = () => {
  const { isMobile } = useContext(AppContext);
  const { t } = useTranslation("common");
  const [isAnimationOn, setIsAnimationOn] = useState<boolean>(false);
  const { ref, inView } = useInView({ rootMargin: "0% 0% -5%" });

  useEffect(() => {
    if (inView) {
      setIsAnimationOn(true);
    }
  }, [inView]);

  return (
    <section className={`${styles.trustedByContainer} ${isAnimationOn && !isMobile ? styles.animated : ""}`} ref={ref}>
      <div className={styles.leftSide}>
        <h2 className={styles.header}>{t("trustedBy.header")}</h2>

        <h3 className={styles.subHeader}>{t("trustedBy.subHeader")}</h3>

        <div className={styles.learnMore}>
          <Link href="/ueber-uns">{t("trustedBy.learnMore")}</Link></div>
      </div>

      <div className={styles.rightSide}>
        <div className={styles.visualHeader}>
          <div className={styles.badge}>
            <strong>50+</strong>
            <span>{t("trustedBy.badgeText")}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trustedby;
